import React from 'react';
import './SubSystemBadge.scss';

interface SubSystemBadgeProps {
    title?: string | null;
    value?: string | null;
    statusColor?: string;
}

const SubSystemBadge: React.FC<SubSystemBadgeProps> = ({
    title,
    value,
}) => {
    // Don't show badge if title or value is missing
    if (!title || !value) return null

    return (
        <div className="subsystem-badge">
            <span className="subsystem-badge__dot" />
            <div className="subsystem-badge__text">
                <div className="subsystem-badge__label">{title}</div>
                <div className="subsystem-badge__value">{value}</div>
            </div>
        </div>
    );
};

export default SubSystemBadge;
